export const UPDATE_OLD_USER_PASSWORD = 'UPDATE_OLD_USER_PASSWORD'
export const UPDATE_OLD_USER_PASSWORD_SUCCESS = 'UPDATE_OLD_USER_PASSWORD_SUCCESS'
export const USER_NEWPASSWORD_SUCCESS_PASSWORD = 'USER_NEWPASSWORD_SUCCESS_PASSWORD'
export const USER_NEWPASSWORD_ERROR_PASSWORD = 'USER_NEWPASSWORD_ERROR_PASSWORD'
